var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: { "dialog-class": "go-modal-resource-index" },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("popup-select-type-reference.title"))),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("popup-select-type-reference.desc"))),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c("div", { staticClass: "go-block-between" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.close },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.buttons.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-primary",
                    attrs: {
                      type: "button",
                      disabled: !_vm.referenceTabSelected,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectedReferenceTab(
                          _vm.referenceTabSelected
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.buttons.next")) +
                        "\n      "
                    ),
                  ]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "go-list-wrap" }, [
        _c(
          "div",
          {
            staticClass:
              "go-list-inner overflow-y-scroll mCustomScrollbar _mCS_3 mCS-autoHide mCS_no_scrollbar",
            staticStyle: { overflow: "visible" },
          },
          [
            _c("ul", { staticClass: "go-card-sub-list go-card-resource" }, [
              _c(
                "li",
                {
                  class: [
                    "go-list-item",
                    {
                      active:
                        _vm.referenceTabSelected ===
                        _vm.REFERENCE_TAB_SELECT.FILES,
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.referenceTabSelected = _vm.REFERENCE_TAB_SELECT.FILES
                    },
                  },
                },
                [
                  _c("div", { staticClass: "go-card-sub" }, [
                    _c("div", { staticClass: "go-card-body" }, [
                      _c("div", { staticClass: "go-card-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.files.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.files.desc"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: [
                    "go-list-item",
                    {
                      active:
                        _vm.referenceTabSelected ===
                        _vm.REFERENCE_TAB_SELECT.SEARCH,
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.referenceTabSelected = _vm.REFERENCE_TAB_SELECT.SEARCH
                    },
                  },
                },
                [
                  _c("div", { staticClass: "go-card-sub" }, [
                    _c("div", { staticClass: "go-card-body" }, [
                      _c("div", { staticClass: "go-card-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.search.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.search.desc"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: [
                    "go-list-item",
                    {
                      active:
                        _vm.referenceTabSelected ===
                        _vm.REFERENCE_TAB_SELECT.URL,
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.referenceTabSelected = _vm.REFERENCE_TAB_SELECT.URL
                    },
                  },
                },
                [
                  _c("div", { staticClass: "go-card-sub" }, [
                    _c("div", { staticClass: "go-card-body" }, [
                      _c("div", { staticClass: "go-card-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.url.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("popup-select-type-reference.types.url.desc")
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: [
                    "go-list-item",
                    {
                      active:
                        _vm.referenceTabSelected ===
                        _vm.REFERENCE_TAB_SELECT.NOTE,
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.referenceTabSelected = _vm.REFERENCE_TAB_SELECT.NOTE
                    },
                  },
                },
                [
                  _c("div", { staticClass: "go-card-sub" }, [
                    _c("div", { staticClass: "go-card-body" }, [
                      _c("div", { staticClass: "go-card-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.note.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.note.desc"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: [
                    "go-list-item",
                    {
                      active:
                        _vm.referenceTabSelected ===
                        _vm.REFERENCE_TAB_SELECT.MY_SCRAP,
                    },
                  ],
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.referenceTabSelected =
                        _vm.REFERENCE_TAB_SELECT.MY_SCRAP
                    },
                  },
                },
                [
                  _c("div", { staticClass: "go-card-sub" }, [
                    _c("div", { staticClass: "go-card-body" }, [
                      _c("div", { staticClass: "go-card-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.scrap.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-card-desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "popup-select-type-reference.types.scrap.desc"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }